import { createApp } from 'vue'
import { createPinia } from 'pinia'
import piniaPluginPersistedstate from 'pinia-plugin-persistedstate'
import i18n from '@/lang/index';
import App from './App.vue'
import vue3GoogleLogin from 'vue3-google-login'
import router from '@/router';
import { createMetaManager} from 'vue-meta'
import 'virtual:svg-icons-register';
import { createHead } from '@vueuse/head';
// import { useIntersectionObserver } from '@vueuse/core'
import VueQrcode from 'vue-qrcode'
// 引入初始化样式文件
import '@/styles/common.scss'

// 引入懒加载指令插件并且注册
import { lazyPlugin } from '@/directives'

// 引入全局组件插件
import { componentPlugin } from '@/components'
// 测试接口函数
// import { getCategory } from '@/apis/testAPI'
// getCategory().then(res => {
//     console.log(res);
// })
//pwa
// if ('serviceWorker' in navigator) {
//   window.addEventListener('load', () => {
//     navigator.serviceWorker.register('/sw.js')
//       .then(registration => console.log('SW registered:', registration))
//       .catch(err => console.log('SW registration failed:', err))
//   })
// }
const app = createApp(App)
const pinia = createPinia()
const head = createHead();
// 注册持久化插件
pinia.use(piniaPluginPersistedstate)
app.use(pinia)
app.use(router)
app.use(head)
app.component('vue-qrcode', VueQrcode)
app.use(vue3GoogleLogin, {
    clientId: '1078297618401-nv93ephen7ccu41lfeim80v0lc77fneo.apps.googleusercontent.com',
  })
app.use(createMetaManager(false, {
    meta: { tag: 'meta', nameless: true }
}));
app.use(i18n)
app.use(lazyPlugin)
app.use(componentPlugin)

// // 检查是否是从桌面启动
function isLaunchedFromHomeScreen() {
  // 1. 检查是否从PWA启动
  const isStandalone = window.matchMedia('(display-mode: standalone)').matches
  const isFromPWA = new URLSearchParams(window.location.search).has('source=pwa')
   // 2. 检查是否已经看过启动页
  const hasSeenSplash = sessionStorage.getItem('hasSeenSplash') === 'true'
   // 3. 如果是首次从PWA启动，则返回true
   return (isStandalone || isFromPWA) && !hasSeenSplash
}

// // 初始路由处理
if (isLaunchedFromHomeScreen()) {
  router.push('/splash') // 从桌面启动，显示启动页
} 
// else {
//   // 2. 检查是否已经看过启动页
//   const hasSeenSplash = sessionStorage.getItem('hasSeenSplash') === 'true'
//  if(window.Telegram?.WebApp.initData!=="" && hasSeenSplash){
//    router.push('/splash') // 从桌面启动，显示启动页
//   }
// }
app.mount('#app')

// // 定义全局指令
// // 这个属于图片懒加载部分
// app.directive('img-lazy', {
//     mounted(el, binding) {
//         // el: 指令绑定的那个元素 img
//         // binding: binding.value 指令等于号后面绑定的表达式的值 图片url
//         console.log(el, binding.value)
//         useIntersectionObserver(
//             el,
//             ([{ isIntersecting }]) => {
//                 console.log(isIntersecting)
//                 if (isIntersecting) {
//                     // 进入视图区域
//                     el.src = binding.value
//                 }
//             },
//         )
//     }
// })